export default {
  paid_off:             'Pago',
  under_payment_plan:   'Em acordo',
  defaulted:            'Em atraso',
  pending:              'A vencer',
  next_payment_message: 'Seu pagamento leva até 3 dias úteis para ser identificado',
};
